// OCT-7341: TreatyApp: File Activity panel — add search, filters, and a count of matching activities - Frontend : ashish.atwal@resolutionlife.com
// Renders text with any portions matching the current search term highlighted.
// Used by the Activity list so search matches (person name / file name) stand out.
import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { splitForHighlight } from './activity-filtering';

type Props = {
  text: string;
  term?: string;
};

export const HighlightedText: FC<Props> = ({ text, term }) => {
  if (!term) {
    return <>{text}</>;
  }

  const segments = splitForHighlight(text, term);

  return (
    <>
      {segments.map((segment, index) =>
        segment.match ? (
          <Text
            // eslint-disable-next-line react/no-array-index-key
            key={`${segment.text}-${index}`}
            as="mark"
            bg="yellow.200"
            color="inherit"
          >
            {segment.text}
          </Text>
        ) : (
          // eslint-disable-next-line react/no-array-index-key
          <Text as="span" key={`${segment.text}-${index}`}>
            {segment.text}
          </Text>
        )
      )}
    </>
  );
};
